module.exports = __webpack_public_path__ + "img/Alcohol_Recall_3_Set.103303f5.png";